/**
 * Collection pages render the same filters twice: a desktop sidebar and the
 * mobile filter drawer. Only one copy may submit, so the copy that is not in
 * use is disabled (disabled fieldsets are left out of form data).
 * Markup contract: <fieldset data-filter-scope="sidebar|drawer">.
 */
const desktop = window.matchMedia('(min-width: 1024px)');

function syncFilterScopes() {
  for (const scope of document.querySelectorAll('fieldset[data-filter-scope]')) {
    const isSidebar = scope.dataset.filterScope === 'sidebar';
    scope.disabled = isSidebar !== desktop.matches;
  }
}

syncFilterScopes();
desktop.addEventListener('change', syncFilterScopes);
